var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161.481,
    height: 161.482,
    viewBox: "0 0 161.481 161.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b2b2b2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8241 11675)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8936.801 -11146.136)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(788.801 -458.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M776.542-528.864A80.832,80.832,0,0,0,695.8-448.123a80.833,80.833,0,0,0,80.741,80.741,80.833,80.833,0,0,0,80.74-80.741A80.832,80.832,0,0,0,776.542-528.864Zm72.74,80.741a72.407,72.407,0,0,1-16.923,46.581l-102.4-102.4a72.4,72.4,0,0,1,46.581-16.924A72.823,72.823,0,0,1,849.282-448.123Zm-145.481,0a72.472,72.472,0,0,1,20.315-50.348L826.889-395.7a72.469,72.469,0,0,1-50.347,20.315A72.823,72.823,0,0,1,703.8-448.123Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M767.981-470.5h7.82a2,2,0,0,1,2,2,6.006,6.006,0,0,0,6,6h17a2,2,0,0,1,2,2v24.819l3.945,3.946a5.845,5.845,0,0,0,.055-.765v-28a6.007,6.007,0,0,0-6-6h-17a2,2,0,0,1-2-2,6.007,6.007,0,0,0-6-6h-11.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M786.769-430.5H748.8a2,2,0,0,1-2-2v-28a2,2,0,0,1,2-2h5a6,6,0,0,0,.894-.074l-3.926-3.926H748.8a6.006,6.006,0,0,0-6,6v28a6.006,6.006,0,0,0,6,6h41.968Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M775.916-441.353A7.984,7.984,0,0,1,769.8-438.5a8.009,8.009,0,0,1-8-8,7.982,7.982,0,0,1,2.852-6.115l-2.827-2.827A11.961,11.961,0,0,0,757.8-446.5a12.013,12.013,0,0,0,12,12,11.959,11.959,0,0,0,8.942-4.026Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPicture);
export default __webpack_public_path__ + "static/media/no-picture.dc01fa5bae5ebd2b519024604154b829.svg";
export { ForwardRef as ReactComponent };